import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiUsersService } from '../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../services/alerts.service';
import { UserCurrencyType } from '../../../../enums/users/user-currency-type.enum';

@Component({
  selector: 'app-user-add-currency-modal',
  templateUrl: './user-add-currency-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class UserAddCurrencyModalComponent {

  @Input() userId: number = 0;

  @ViewChild('modal') modal!: ModalDirective;

  protected readonly UserCurrencyType = UserCurrencyType;
  protected readonly isNaN = isNaN;

  isLoading: boolean = false;
  currencyType: UserCurrencyType = UserCurrencyType.Credit;
  currencyQuantity: number | null = null;
  currencyTicketCost: number | null = null;

  private callbackSaved?: () => void;

  constructor(private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.currencyType = UserCurrencyType.Credit;
    this.currencyQuantity = null;
    this.currencyTicketCost = null;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiUsersService.addUserCurrencyQuantity(this.userId, this.currencyType, this.currencyQuantity ?? 0, this.currencyTicketCost ?? 0).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Add currency success !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('An error occur during currency add : ' + error);
      }
    );
  }
}
